import { TypeCta } from "@contentful/types";
import { faXmark } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Button } from "@yardzen/ui/components/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@yardzen/ui/components/dialog";

export function ContractorFormModal({
  contentfulCTA,
}: {
  contentfulCTA: TypeCta<"WITHOUT_UNRESOLVABLE_LINKS">;
}) {
  return (
    <Dialog>
      <VisuallyHidden asChild>
        <DialogTitle>{contentfulCTA.fields.title}</DialogTitle>
      </VisuallyHidden>
      <DialogTrigger asChild>
        <Button
          className="bg-brand-tertiary-50 text-brand-primary-darker w-full whitespace-nowrap px-6 py-3 font-semibold md:w-auto"
          variant={contentfulCTA.fields.variant}
        >
          {contentfulCTA.fields.buttonText}
        </Button>
      </DialogTrigger>
      <DialogContent className="w-11/12 max-w-screen-lg rounded-lg border-0 p-0 md:w-4/6">
        <DialogClose className="bg-brand-primary-light absolute -top-10 right-0 z-20 -mt-1 h-10 w-10 rounded-full md:-right-10">
          <FontAwesomeIcon
            icon={faXmark}
            className="mt-0.5 h-4 w-4 text-white"
          />
          <span className="sr-only">Close</span>
        </DialogClose>
        <div className="relative z-10 h-[90vh] max-h-[990px]">
          <iframe
            className="absolute h-full w-full rounded-lg"
            src={`${contentfulCTA.fields.url}?autoplay=1`}
            title={contentfulCTA.fields.url}
          ></iframe>
        </div>
      </DialogContent>
    </Dialog>
  );
}
